import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_InputCodeEditor = _resolveComponent("InputCodeEditor")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createBlock(_component_GenericFormWrapper, {
    submitData: _ctx.submitData,
    pageUI: _ctx.pageUI
  }, {
    content: _withCtx(({errors}) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.contentBlock.title!.nl,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.title!.nl) = $event)),
              _ctx.onFormDataChanged
            ],
            label: _ctx.$t('title'),
            name: _ctx.$t('title'),
            rules: "required|max:255",
            errors: errors
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "errors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_InputCodeEditor, {
            modelValue: _ctx.contentBlock.content!.nl,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.content!.nl) = $event)),
              _ctx.onFormDataChanged
            ],
            languages: ['css', 'CSS'],
            height: "80vh",
            errors: errors
          }, null, 8, ["modelValue", "onUpdate:modelValue", "errors"])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_base_offcanvas_button_close, {
        ref: "closeButton",
        class: "btn btn-light",
        disabled: _ctx.pageUI.isSubmitting()
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["submitData", "pageUI"]))
}